import { Directive, ElementRef, Output, EventEmitter, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective {
  @Input() excludeClasses: string[] = [];
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    const clickedInside = this.el.nativeElement.contains(targetElement);

    if (!clickedInside && !this.isExcludedElement(targetElement)) {
      this.clickOutside.emit();
    }
  }

  private isExcludedElement(targetElement: HTMLElement): boolean {
    return this.excludeClasses.some(className =>
      targetElement.classList.contains(className) ||
      this.hasParentWithClass(targetElement, className)
    );
  }

  private hasParentWithClass(element: HTMLElement, className: string): boolean {
    while (element && element !== document.body) {
      if (element.classList.contains(className)) {
        return true;
      }
      element = element.parentElement!;
    }
    return false;
  }
}
